module.exports = __webpack_public_path__ + "static/media/loading-white.79a1597d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loading-white.svg
// module id = 76
// module chunks = 0